import { PageLastIcon } from './PageLastIcon';

/**
 * author: Google
 * id CF9B4635-FE27-4DA5-BE51-F5F4116AFC54
 * name page-last
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/page-last.svg
 * tags
 */
export const LastPageIcon = PageLastIcon;
export default LastPageIcon